import React, { useEffect } from "react";

import AOS from "aos";
import "aos/dist/aos.css";
import "./Home.css";
import NavBar from "./NavBar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import billboard from "./images/billboard.jpg";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { useState } from "react";
import api from "./Dashboard/Api";

export default function Home() {
  // scroll animation
  useEffect(() => {
    AOS.init({ duration: 1800, once: true });
  }, []);

  // post api
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData(e.target);

    // هنا بجهز البادي اللي هيتبعت للـ API
    const payload = {
      Name: formData.get("name"),
      Phone: formData.get("Phone"),
      Email: formData.get("email"),
      Message: formData.get("message"),
      SubmittedAt: new Date().toISOString(),
    };

    try {
      const response = await api.post(
        "/api/shared/Home/ContactUs",
        payload, // هنا بعت JSON مش FormData
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      alert("✅ Success: " + response.data.message);
    } catch (error) {
      console.error("❌ Error:", error);
      alert("❌ Something went wrong, try again!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="home">
      <div className="hero">
        <NavBar />
        <video autoPlay muted loop playsInline className="bg-video">
          <source
            src="/videos/3029469-hd_1920_1080_24fps.mp4"
            type="video/mp4"
          />
          متصفحك لا يدعم الفيديو
        </video>

        <div className="blur">
          {" "}
          <div className="content text-black container">
            <div className="info" data-aos="fade-right">
              <p>WE</p>
              <p>HELP</p>
              <p>DEVELOP</p>
              <p>BRANDS</p>
            </div>

            <div className="details" data-aos="zoom-in">
              <p className="">
                <span className=" text-uppercase ">spark </span> is a leading
                BTL marketing agency in the MENA region with over 200 employees,
                offices in Cairo and Dubai, partnerships with over 600 clients,
                and a privately-owned production house. We are proud of our
                reputation and plan to surpass even higher benchmarks in the
                future.
              </p>
              <Link to={"/about"} className="shadow__btn">
                Learn More
              </Link>{" "}
            </div>
          </div>
        </div>
      </div>

      <div className="about-section">
        <div className="container">
          <div className=" row">
            <div className="about-photo" data-aos="zoom-in">
              <img src={billboard} alt="" />
            </div>
            <div className="info" data-aos="fade-left">
              <h2 className=" text-uppercase">spark</h2>
              <p>
                At Innovation Crew, innovation isn't just a buzzword; it's woven
                into the fabric of everything we do. We're not your typical BTL
                marketing agency. We're the disruptors, the dreamers, and the
                doers.{" "}
              </p>
              <Link to={"/contact"} className="Btn"></Link>
            </div>
          </div>
        </div>
      </div>
      <div className="home-billboards-section py-5">
        <div className="container">
          <div
            className="home-home-section-header text-center mb-5"
            data-aos="fade-up"
          >
            <h2 className="text-uppercase home-section-title">
              Our Billboards
            </h2>
            <p className="home-section-subtitle">
              Premium advertising spaces across prime locations
            </p>
          </div>

          <div className="home-billboards-grid">
            <div
              className="home-billboard-card"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <div className="home-card-icon">
                <i className="fas fa-digital-tachograph"></i>
              </div>
              <h3>Digital Billboards</h3>
              <p>
                High-resolution digital displays with dynamic content
                capabilities
              </p>
            </div>

            <div
              className="home-billboard-card"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="home-card-icon">
                <i className="fas fa-traffic-light"></i>
              </div>
              <h3>Highway Billboards</h3>
              <p>
                Strategic locations along major highways for maximum visibility
              </p>
            </div>

            <div
              className="home-billboard-card"
              data-aos="zoom-in"
              data-aos-delay="300"
            >
              <div className="home-card-icon">
                <i className="fas fa-city"></i>
              </div>
              <h3>Urban Billboards</h3>
              <p>Prime spots in city centers and high-traffic urban areas</p>
            </div>

            <div
              className="home-billboard-card"
              data-aos="zoom-in"
              data-aos-delay="400"
            >
              <div className="home-card-icon">
                <i className="fas fa-shopping-center"></i>
              </div>
              <h3>Commercial Billboards</h3>
              <p>Locations near shopping malls and commercial districts</p>
            </div>
          </div>

          <div className="text-center mt-5" data-aos="fade-up">
            <Link to="/billboards" className="home-billboards-btn">
              Explore All Billboards
            </Link>
          </div>
        </div>
      </div>
      <div className="services">
        <div className="services-blur"></div>
        <div className="container overlay">
          <h2 className=" text-uppercase">services</h2>
          <div className="row">
            <div className="service" data-aos="zoom-in">
              <div className="hr"></div>
              <h3>Outdoor Advertising</h3>
            </div>
            <div className="service" data-aos="zoom-in">
              <div className="hr"></div>
              <h3>Billboard Rental</h3>
            </div>
            <div className="service" data-aos="zoom-in">
              <div className="hr"></div>
              <h3>Media Planning & Buying</h3>
            </div>
            <div className="service" data-aos="zoom-in">
              <div className="hr"></div>
              <h3>Design & Printing</h3>
            </div>
            <div className="service" data-aos="zoom-in">
              <div className="hr"></div>
              <h3>Installation & Maintenance</h3>
            </div>
            <div className="service" data-aos="zoom-in">
              <div className="hr"></div>
              <h3>Campaign Managemen</h3>
            </div>
            <div className="service" data-aos="zoom-in">
              <div className="hr"></div>
              <h3>Digital Billboards</h3>
            </div>
            <div className="service" data-aos="zoom-in">
              <div className="hr"></div>
              <h3>Market Research</h3>
            </div>
          </div>
        </div>
      </div>
      <div className="clients-section py-5">
        <div className="container">
          <div className="home-section-header text-center mb-5" data-aos="fade-up">
            <h2 className="text-uppercase">Our Clients</h2>
            <p>Trusted by leading brands and organizations</p>
          </div>

          <div className="clients-grid">
            <div
              className="client-card"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <div className="card-icon">
                <i className="fas fa-building"></i>
              </div>
              <h3>Corporate Brands</h3>
              <p>Leading corporations that trust our advertising solutions</p>
            </div>

            <div
              className="client-card"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="card-icon">
                <i className="fas fa-store"></i>
              </div>
              <h3>Retail Businesses</h3>
              <p>Local and international retail chains</p>
            </div>

            <div
              className="client-card"
              data-aos="zoom-in"
              data-aos-delay="300"
            >
              <div className="card-icon">
                <i className="fas fa-globe"></i>
              </div>
              <h3>International Brands</h3>
              <p>Global companies expanding in the region</p>
            </div>

            <div
              className="client-card"
              data-aos="zoom-in"
              data-aos-delay="400"
            >
              <div className="card-icon">
                <i className="fas fa-star"></i>
              </div>
              <h3>Startups</h3>
              <p>Innovative startups building their brand presence</p>
            </div>
          </div>

          <div className="text-center mt-5" data-aos="fade-up">
            <Link to="/clintes" className="clients-btn">
              View All Clients
            </Link>
          </div>
        </div>
      </div>
      <div className="form-section py-5">
        <div className="container">
          <div className="form-container" data-aos="fade-right">
            <h2 className="form-title">Get In Touch</h2>
            <p className="form-subtitle">
              We'll get back to you as soon as possible
            </p>
            <form className="form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder=" "
                  required
                />
                <label htmlFor="name">Name</label>
              </div>

              <div className="form-group">
                <input
                  type="tel"
                  id="number"
                  name="Phone"
                  placeholder=" "
                  required
                />
                <label htmlFor="number">Phone Number</label>
              </div>

              <div className="form-group">
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder=" "
                  required
                />
                <label htmlFor="email">Email Address</label>
              </div>

              <div className="form-group">
                <textarea
                  id="textarea"
                  name="message"
                  placeholder=" "
                  rows={4}
                  required
                />
                <label htmlFor="textarea">How Can We Help You?</label>
              </div>

              <button
                className="form-submit-btn"
                type="submit"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Message"}
              </button>
            </form>{" "}
          </div>

          <div className="form-animation" data-aos="fade-left">
            <DotLottieReact
              src="https://lottie.host/9fa0dd69-b498-4cce-b8c9-88f978716815/OvvIBgTUjp.lottie"
              loop
              autoplay
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
